import { cn } from "@/lib/utils"

export interface HandoverBarProps {
  employeeCode: string
  sessionId: string
  checked?: boolean
  onCheckedChange?: (checked: boolean, sessionId: string) => void
}

export function HandoverBar({
  employeeCode,
  sessionId,
  checked,
  onCheckedChange,
}: HandoverBarProps) {
  const isHandoverActive = !!checked

  function handleCheckedChange(nextChecked: boolean) {
    if (nextChecked === isHandoverActive) {
      return
    }

    if (onCheckedChange) {
      onCheckedChange(nextChecked, sessionId)
    }
  }

  return (
    <div className="px-4 pt-3 text-button-black">
      <div className="flex justify-center">
        <div
          role="tablist"
          aria-label={`Sheet mode for handover from ${employeeCode}`}
          className="inline-grid grid-cols-2 gap-1 rounded-xl border border-slate-200 bg-slate-100 p-1 shadow-sm"
        >
          <button
            type="button"
            role="tab"
            aria-selected={!isHandoverActive}
            onClick={() => handleCheckedChange(false)}
            className={cn(
              "h-10 min-w-[96px] rounded-[10px] px-5 text-center text-sm font-semibold tracking-[0.01em] transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue/40 focus-visible:ring-offset-1",
              !isHandoverActive
                ? "bg-blue text-white shadow-sm"
                : "bg-white text-slate-600 hover:text-blue"
            )}
          >
            Sheet
          </button>

          <button
            type="button"
            role="tab"
            aria-selected={isHandoverActive}
            onClick={() => handleCheckedChange(true)}
            className={cn(
              "h-10 min-w-[96px] rounded-[10px] px-5 text-center text-sm font-semibold tracking-[0.01em] transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue/40 focus-visible:ring-offset-1",
              isHandoverActive
                ? "bg-blue text-white shadow-sm"
                : "bg-white text-slate-600 hover:text-blue"
            )}
          >
            Handover
          </button>
        </div>
      </div>

      {employeeCode ? (
        <div className="mt-2 flex justify-center">
          <span className="rounded-full border border-blue-fill/15 bg-blue-fill/5 px-3 py-1 text-xs font-medium text-blue-fill">
            {employeeCode}
          </span>
        </div>
      ) : null}
    </div>
  )
}
